module.exports = __webpack_public_path__ + "assets/down-arrow-white.bf25b328591cb4c0e9711bd764703ac8.png";